module.exports = __webpack_public_path__ + "static/media/66.3684d9c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/66.jpg
// module id = 626
// module chunks = 0